import React from 'react';

function linkify(inputText) {
  var replacedText;
  var replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  replacedText = inputText.replace(replacePattern1, '<a href="$1" class="text-link" target="_blank" rel="noopener noreferrer">$1</a>');
  var replacePattern2 = /(^|\s)(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(replacePattern2, '$1<a href="https://$2" class="text-link"  target="_blank" rel="noopener noreferrer">$2</a>');
  return replacedText;
}
var sanitize = function sanitize(text) {
  return text.replace(/</g, "&#60;").replace(/>/g, "&#62;").replace(/’/g, "'");
};
var addNewlines = function addNewlines(text) {
  return text.replace(/\n/g, "<br>");
};
var nullSafe = function nullSafe(text) {
  return text ? text : "";
};
var DecoratedText = function DecoratedText(_a) {
  var _b = _a.text,
    text = _b === void 0 ? "" : _b,
    _c = _a.decorator,
    decorator = _c === void 0 ? function (text) {
      return text;
    } : _c;
  return /*#__PURE__*/React.createElement("span", {
    className: "text-darkest",
    dangerouslySetInnerHTML: {
      __html: decorator(addNewlines(linkify(sanitize(nullSafe(text)))))
    }
  });
};

export { DecoratedText };
//# sourceMappingURL=index.es.js.map
